import { HttpErrorResponse } from '@angular/common/http'
import { createAction, props } from '@ngrx/store'
import { ItemDispatchesEntity } from './item-dispatches.models'

export const loadItemDispatches = createAction('[ItemDispatches Page] Init')

export const loadItemDispatchesSuccess = createAction(
  '[ItemDispatches/API] Load ItemDispatches Success',
  props<{ itemDispatches: ItemDispatchesEntity[] }>(),
)

export const loadItemDispatchesFailure = createAction(
  '[ItemDispatches/API] Load ItemDispatches Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const dispatchItem = createAction('[ItemDispatches/API] Dispatch Item', props<{ item: string }>())

export const dispatchItems = createAction(
  '[ItemDispatches/API] Dispatch Items',
  props<{ items: string[]; deliveryAddress?: string }>(),
)

export const dispatchItemSuccess = createAction(
  '[ItemDispatches/API] Dispatch Item Success',
  props<{ itemDispatch: ItemDispatchesEntity }>(),
)

export const dispatchItemFailure = createAction('[ItemDispatches/API] Dispatch Item Failure')

export const dispatchItemsSuccess = createAction(
  '[ItemDispatches/API] Dispatch Items Success',
  props<{ itemDispatches: ItemDispatchesEntity[] }>(),
)

export const dispatchItemsFailure = createAction('[ItemDispatches/API] Dispatch Items Failure')

export const clearItemDispatches = createAction('[ItemDispatches/Page] Clear Item Dispatches')

export const deleteItemDispatch = createAction(
  '[ItemDispatches/API] Delete Item Dispatch',
  props<{ itemDispatchId: string }>(),
)
export const deleteItemDispatchSuccess = createAction(
  '[ItemDispatches/API] Delete Item Dispatch Success',
  props<{ itemDispatchUuid: string }>(),
)
export const deleteItemDispatchFailure = createAction('[ItemDispatches/API] Delete Item Dispatch Failure')
